import {
  Ban,
  Briefcase,
  Contact,
  Flame,
  FlaskConical,
  Frown,
  Gamepad2,
  Gift,
  Heart,
  HatGlasses,
  Laptop,
  Lightbulb,
  MailOpen,
  Megaphone,
  Meh,
  Monitor,
  Plug,
  Search,
  ShieldAlert,
  Smile,
  Thermometer,
  TriangleAlert,
  Trophy,
  Zap,
} from "lucide-react"
import type { IconName } from "lucide-react/dynamic"
import dynamicIconImports from "lucide-react/dynamicIconImports"

const traitsIconMap = {
  "fa fa-trophy text-warning": Trophy,
  "fa fa-heart text-danger": Heart,
  "fa fa-smile text-success": Smile,
  "fa fa-briefcase text-warning": Briefcase,
  "fa fa-gift text-success": Gift,
  "fa fa-address-card text-success": Contact,
  "fa fa-bullhorn text-info": Megaphone,
  "fa fa-lightbulb text-success": Lightbulb,
  "fa fa-bullhorn text-success": Megaphone,
  "fa fa-neutral-o text-success": Meh,
  "fa fa-flask": FlaskConical,
  "fa fa-search text-info": Search,
  "fa fa-thermometer-three-quarters text-danger": Thermometer,
  "fa fa-bolt text-primary": Zap,
  "fa fa-plug text-success": Plug,
  "fa fa-frown-o text-success": Frown,
  "fa fa-fire text-info": Flame,
  "fa fa-gamepad text-warning": Gamepad2,
  "fa fa-desktop text-success": Monitor,
  "fa fa-ban text-danger": Ban,
  "fa fa-exclamation-triangle": TriangleAlert,
  "fa fa-laptop text-primary": Laptop,
  "fa fa-envelope-o": MailOpen,
  "fa fa-shield-exclamation text-warning": ShieldAlert,
  "fa fa-face-disguise text-danger": HatGlasses,
} as const

type BackendIconKey = keyof typeof traitsIconMap
type IconComponent = (typeof traitsIconMap)[BackendIconKey]

export const traitsIconParser = (icon: string): IconComponent | null =>
  (icon ? traitsIconMap[icon as BackendIconKey] : null) ?? null

// lucide_trait_icon holds a kebab-case Lucide icon name, e.g. "trophy"; the color token lives in trait_style.
// Unknown names or nulls fall back to the old Font Awesome trait_icon translation above.
export const parseLucideTraitIcon = (
  lucideTraitIcon: string | null | undefined,
): IconName | null => {
  const name = lucideTraitIcon?.trim()
  return name && name in dynamicIconImports ? (name as IconName) : null
}

export const iconColorClass = (iconClass: string | null | undefined) => {
  if (!iconClass) return "tw:text-muted-foreground"
  if (iconClass.includes("text-warning")) return "tw:text-yellow-500"
  if (iconClass.includes("text-success")) return "tw:text-green-600"
  if (iconClass.includes("text-danger")) return "tw:text-red-600"
  if (iconClass.includes("text-info")) return "tw:text-sky-500"
  if (iconClass.includes("text-primary")) return "tw:text-blue-700"
  return "tw:text-muted-foreground"
}
